import type { OnBeforeUploadResult } from 'hooks/useUpload/types';
import { showModal } from 'zustand-stores/modalStore';

import type { CropImageModalProps } from './CropImageModal';

// TODO(@paprikka): add options once we need to support multiple aspect ratios
// (not the case for now)
export type CropImageOptions = {
  aspectRatio?: number;
  initialAspectRatio?: number;
};

export async function cropImage(
  file: File,
  options: CropImageOptions,
): Promise<OnBeforeUploadResult> {
  // TODO(@paprikka): does this need to use showModal or can we use Portals instead?
  return new Promise((resolve) => {
    showModal('CROP_IMAGE', {
      file,
      options: { ...options },
      onSuccess: (processedFile: File) =>
        resolve({ type: 'continue', file: processedFile }),
      onCancel: () => resolve({ type: 'cancel', reason: 'user_cancelled' }),
      onError: (error: Error) => resolve({ type: 'error', error }),
    } as unknown as CropImageModalProps);
  });
}
